export enum AppDomains {
  interink = "https://client.interlinkgs.com",
  dforward = "https://dforward.kz",
}
